import type { ReactNode } from 'react';
import type { UrlObject } from 'url';

import { ProductTypeEnum, type ProductTypeOptions } from '@/types/product';
import { getLinkAriaLabel } from '@/utils/urlUtils';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

const NON_LINKABLE_PRODUCT_TYPES: ProductTypeOptions[] = [
  ProductTypeEnum.Tool,
  ProductTypeEnum.Buckle,
];

export interface ProductLineLinkProps {
  children: ReactNode;
  href?: string | UrlObject;
  localeCode: string;
  productName?: string;
  productType: ProductTypeOptions;
}

/**
 * Wraps a bag / mini-cart line item (image or name) in a link to its PDP.
 * Renders the children as-is when the product type has no PDP.
 */
export const ProductLineLink = ({
  children,
  href,
  localeCode,
  productName,
  productType,
}: ProductLineLinkProps) => {
  if (
    !href ||
    href === '#' ||
    NON_LINKABLE_PRODUCT_TYPES.includes(productType)
  ) {
    return <>{children}</>;
  }

  return (
    <LinkWithLocale
      aria-label={
        getLinkAriaLabel(href, localeCode) ||
        `View ${productName ?? ''} details`
      }
      href={href}
    >
      {children}
    </LinkWithLocale>
  );
};
